import Button from '@/components/base/Button';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center bg-foreground-950 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20flat%20lay%20fashion%20composition%20on%20dark%20concrete%20surface%2C%20sneakers%20hoodies%20jackets%20and%20designer%20accessories%20scattered%20in%20creative%20chaos%2C%20dramatic%20side%20lighting%20with%20golden%20warm%20tones%2C%20high%20contrast%20shadows%2C%20luxury%20streetwear%20aesthetic%2C%20premium%20editorial%20fashion%20photography%2C%20rich%20texture%20details%20visible%2C%20moody%20sophisticated%20atmosphere%2C%20dark%20background%20with%20products%20popping&width=1800&height=1200&seq=hero-v2-main&orientation=landscape"
          alt="CSSBuy Spreadsheet - Produtos organizados"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-foreground-950"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full pt-24 pb-16 px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-10 lg:gap-16">
            {/* Left: Title */}
            <div className="flex-1 w-full">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-xs font-semibold mb-6">
                <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
                Atualizado Hoje
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-background-50 leading-tight">
                Melhor CSSBuy
                <br />
                Spreadsheet 2026
              </h1>
            </div>

            {/* Right: Description + CTA */}
            <div className="flex-1 w-full flex flex-col items-start gap-5">
              <p className="text-background-50/80 text-base md:text-lg leading-relaxed max-w-md">
                Encontre o maior diretório de cssbuy spreadsheet atualizado diariamente. Mais de 3000 produtos organizados em categorias exclusivas para compradores no Brasil.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Button
                  href="https://kaspreadsheet.com"
                  variant="primary"
                  size="lg"
                  className="bg-background-50 text-foreground-950 hover:bg-background-100 gap-2"
                >
                  buy it now
                  <i className="ri-arrow-right-line text-lg"></i>
                </Button>
                <Button
                  href="https://kaspreadsheet.com"
                  variant="outline"
                  size="lg"
                  className="border-background-50/30 text-background-50 hover:border-background-50 hover:bg-background-50/10 gap-2"
                >
                  cssbuy sheet
                  <i className="ri-external-link-line text-lg"></i>
                </Button>
              </div>
              <div className="flex flex-wrap items-center gap-4 mt-2">
                <span className="flex items-center gap-1.5 text-background-50/60 text-xs">
                  <i className="ri-check-line text-accent-400"></i>
                  Sneakers
                </span>
                <span className="flex items-center gap-1.5 text-background-50/60 text-xs">
                  <i className="ri-check-line text-accent-400"></i>
                  Streetwear
                </span>
                <span className="flex items-center gap-1.5 text-background-50/60 text-xs">
                  <i className="ri-check-line text-accent-400"></i>
                  Hoodies
                </span>
                <span className="flex items-center gap-1.5 text-background-50/60 text-xs">
                  <i className="ri-check-line text-accent-400"></i>
                  Jaquetas
                </span>
                <span className="flex items-center gap-1.5 text-background-50/60 text-xs">
                  <i className="ri-check-line text-accent-400"></i>
                  Acessórios
                </span>
                <span className="flex items-center gap-1.5 text-background-50/60 text-xs">
                  <i className="ri-check-line text-accent-400"></i>
                  Marcas famosas
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}